const PropTypes = require('prop-types');
const React = require('react');
const Tooltip = require('../tooltip');
const UrlHelpers = require('components/shared/url_helpers.js');
const NewBrandRequest = require('components/listing_form/new_brand_request');
const AutoSuggestInput = require('./auto_suggest_input');
const APIRequest = require('components/api_request.js');

const MAX_LENGTH = 100;
const MAKE_HTML_ID = 'product_make';
const MODEL_HTML_ID = 'product_model';

class MakeModel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      make: props.make || '',
      model: props.model || '',
      canonicalMake: props.canonicalMake || '',
      brandFindResponse: null,
      hasSearchedBrand: false,
    };

    this.onBlurMake = this.onBlurMake.bind(this);
    this.onAutosuggestMakeChange = this.onAutosuggestMakeChange.bind(this);
    this.onAutosuggestModelChange = this.onAutosuggestModelChange.bind(this);
  }

  onBlurMake(event) {
    if (event.target.value) {
      this.findBrandByName(event.target.value);
    }
  }

  onAutosuggestMakeChange(event, { newValue }) {
    this.setState({
      make: newValue,
    });

    // If the user deletes the make value
    // pretend we are starting over.
    // This way if they start typing again
    // the new brand request form doesn't
    // immediately pop open
    if (newValue.length === 0) {
      this.setState({
        hasSearchedBrand: false,
      });
    }
  }

  onAutosuggestModelChange(event, { newValue }) {
    this.setState({
      model: newValue,
    });
  }

  findBrandByName(name) {
    APIRequest.V3.get(
      UrlHelpers.brandFindByNamePath({ name })
    )
      .then((response) => {
        this.setState({
          hasSearchedBrand: true,
          brandFindResponse: response,
        });
      });
  }

  shouldShowBrandWarning() {
    return this.state.make.length > 0
      && this.state.hasSearchedBrand
      && !this.brandFound();
  }

  brandFound() {
    return this.state.brandFindResponse && Object.keys(this.state.brandFindResponse).length > 0;
  }

  renderEnabledMakeInput() {
    const inputProps = {
      name: this.props.nameForInputMake,
      className: 'autosuggest-input__make',
      onBlur: this.onBlurMake,
      'data-listing-form': 'make',
      'data-pg-match': 'required',
      maxLength: MAX_LENGTH,
      onChange: this.onAutosuggestMakeChange,
      required: 'required',
      id: MAKE_HTML_ID,
    };

    return (
      <div>
        <AutoSuggestInput
          value={this.state.make}
          list={this.props.autocompleteMakes}
          inputProps={inputProps}
        />
      </div>
    );
  }

  renderDisabledMakeInput() {
    return (
      <Tooltip
        title={I18n.t('listingForm.makeModelForm.make.lockedTooltipHtml')}
      >
        <input
          name={this.props.nameForInputMake}
          value={this.state.canonicalMake}
          disabled
          className="autosuggest-input__make"
          type="text"
        />
      </Tooltip>
    );
  }

  renderMakeInput() {
    if (this.props.canChangeMake) {
      return this.renderEnabledMakeInput();
    }

    return this.renderDisabledMakeInput();
  }

  renderMake() {
    return (
      <div className="g-col-4 g-col-mobile-12">
        <div className="form-group">
          <div className="form-group__header">
            <label htmlFor={MAKE_HTML_ID}>
              {I18n.t('listingForm.makeModelForm.make.label')}
            </label>
          </div>
          <div className="form-group__fields">
            {this.renderMakeInput()}
            <p className="form-group__help-text">
              {I18n.t('listingForm.makeModelForm.make.labelHint')}
            </p>
          </div>
        </div>
      </div>
    );
  }

  renderBrandWarningSection() {
    if (!this.shouldShowBrandWarning()) {
      return null;
    }

    return (
      <NewBrandRequest
        newBrand={this.state.make}
      />
    );
  }

  renderModelInput() {
    const inputProps = {
      name: this.props.nameForInputModel,
      className: 'autosuggest-input__model',
      'data-listing-form': 'model',
      'data-pg-match': 'required',
      maxLength: MAX_LENGTH,
      onChange: this.onAutosuggestModelChange,
      required: 'required',
      id: MODEL_HTML_ID,
    };

    return (
      <div>
        <AutoSuggestInput
          value={this.state.model}
          list={this.props.autocompleteModels}
          inputProps={inputProps}
        />
      </div>
    );
  }

  renderModel() {
    return (
      <div className="g-col-8 g-col-mobile-12 mobile-mt-1">
        <div className="form-group">
          <div className="form-group__header">
            <label htmlFor={MODEL_HTML_ID}>
              {I18n.t('listingForm.makeModelForm.model.label')}
            </label>
          </div>
          <div className="form-group__fields">
            {this.renderModelInput()}
            <p className="form-group__help-text">
              {I18n.t('listingForm.makeModelForm.model.labelHint')}
            </p>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="g-container">
          {this.renderMake()}
          {this.renderModel()}
        </div>
        <div>
          {this.renderBrandWarningSection()}
        </div>
      </div>
    );
  }
}

MakeModel.propTypes = {
  make: PropTypes.string,
  canonicalMake: PropTypes.string,
  canChangeMake: PropTypes.bool,
  model: PropTypes.string,
  nameForInputModel: PropTypes.string.isRequired,
  nameForInputMake: PropTypes.string.isRequired,
  autocompleteMakes: PropTypes.array,
  autocompleteModels: PropTypes.array,
};

MakeModel.defaultProps = {
  autocompleteMakes: [],
  autocompleteModels: [],
};

module.exports = MakeModel;



// WEBPACK FOOTER //
// ./javascripts/components/listing_form/make_model.jsx